"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$maxBy = exports.$date = exports.$join = exports.$find = exports.$split = exports.$findAll = exports.$get = exports.$spread = exports.$last = exports.$mul = exports.$div = exports.$sum = exports.$now = exports.$format = exports.$length = exports.$concatArray = exports.$concat = exports.$or = exports.$and = exports.$in = exports.$gt = exports.$neq = exports.$eq = exports.$each = exports.$if = exports.$ref = void 0;
// SDK
function $ref(name, defaultValue) {
    return { $: name, default: defaultValue };
}
exports.$ref = $ref;
function $if(condition, then, otherwise) {
    return { $: { type: 'if', condition: condition, then: then, otherwise: otherwise } };
}
exports.$if = $if;
function $each(collection, as, result) {
    return { $: { type: 'each', in: collection, as: as, return: result } };
}
exports.$each = $each;
function $eq(a, b) {
    return { $: { type: '==', a: a, b: b } };
}
exports.$eq = $eq;
function $neq(a, b) {
    return { $: { type: 'neq', a: a, b: b } };
}
exports.$neq = $neq;
function $gt(a, b) {
    return { $: { type: '>', a: a, b: b } };
}
exports.$gt = $gt;
function $in(a, b) {
    return { $: { type: 'in', a: a, b: b } };
}
exports.$in = $in;
function $and() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return { $: { type: 'and', values: values } };
}
exports.$and = $and;
function $or() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return { $: { type: 'or', values: values } };
}
exports.$or = $or;
function $concat() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return { $: { type: 'concat', values: values } };
}
exports.$concat = $concat;
function $concatArray(values) {
    return { $: { type: 'concat', values: values } };
}
exports.$concatArray = $concatArray;
function $length(values) {
    return { $: { type: 'length', values: values } };
}
exports.$length = $length;
function $format(value, formatter) {
    return { $: { type: 'format', value: value, formatter: formatter } };
}
exports.$format = $format;
exports.$now = { $: { type: 'now' } };
function $sum(values) {
    return { $: { type: 'sum', values: values } };
}
exports.$sum = $sum;
function $div(a, b) {
    return { $: { type: 'div', a: a, b: b } };
}
exports.$div = $div;
function $mul(a, b) {
    return { $: { type: 'mul', a: a, b: b } };
}
exports.$mul = $mul;
function $last(values) {
    return { $: { type: 'last', values: values } };
}
exports.$last = $last;
function $spread(value, updatedFields) {
    return { $: { type: 'spread', value: value, updatedFields: updatedFields } };
}
exports.$spread = $spread;
function $get(value, getter, defaultValue) {
    return { $: { type: 'get', value: value, getter: getter, default: defaultValue } };
}
exports.$get = $get;
function $findAll(collection, as, predicate) {
    return { $: { type: 'find-all', in: collection, as: as, predicate: predicate } };
}
exports.$findAll = $findAll;
function $split(str, splitBy) {
    return { $: { type: 'split', in: str, splitBy: splitBy } };
}
exports.$split = $split;
function $find(collection, as, predicate, defaultValue) {
    return { $: { type: 'find', in: collection, as: as, predicate: predicate, defaultValue: defaultValue } };
}
exports.$find = $find;
function $join(collection, joiner) {
    return { $: { type: 'join', collection: collection, joiner: joiner } };
}
exports.$join = $join;
function $date(init, formula) {
    return { $: { type: 'date', init: init, formula: formula } };
}
exports.$date = $date;
function $maxBy(collection, as, expression) {
    return { $: { type: 'max-by', in: collection, as: as, expression: expression } };
}
exports.$maxBy = $maxBy;
//# sourceMappingURL=sdk.js.map